import type {
	Components,
} from '@mui/material'

export const materialUIDividerTheme: {
	components: Components
} = {
	components: {
		MuiDivider: {
			styleOverrides: {
				root: {
					backgroundColor: 'var(--outline-color-base)',
				},
			},
		},
	},
}
